import React, { FC } from "react";
import { Draggable } from "react-beautiful-dnd";
import { Iconify } from 'src/UIKit/Iconify';
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { ICategory } from "src/modules/categories/entity/categories/ICategory";
import {ContextMenu} from "../../../../../UIKit/ContextMenu";
import { CategoryDroppableContainer } from "../categoryDroppableContainer";
import { useUiContext } from "src/UIProvider";
import {SerialCategoryContextMenu} from "../serialCategoryContextMenu";
import { StyledDraggedComponent, styles } from "./styles";
import { Image } from "src/UIKit/Image";
import { IOSSwitch } from "src/UIKit/IOSSwitch";
import { useCategoryListItem } from "src/modules/categories/presenters/useCategoryListItem";

interface IProps {
    category: ICategory;
    index: number;
    level: number;
};

export const CategoryListItem: FC<IProps> = ({ category, index, level }) => {
    const { t } = useUiContext();
    const { parent, onDelete, open, onOpenCloseAccordion, handleOpenMenu, openMenu, handleCloseMenu, onEdit, onCreateSerialCategory, onActiveSwitch } = useCategoryListItem(category);

    return (
        <Draggable key={`Draggable${category.id}test`} draggableId={`${category.id}`} index={index} isDragDisabled={parent?.slug !== 'home'}>
            {(provided, snapshot) => (
                <Box flexDirection={'row'} ref={provided.innerRef}{...provided.draggableProps} >
                    <StyledDraggedComponent isDragging={snapshot.isDragging} index={index}>
                        <Box sx={styles.row} pl={(level * 4) + 2}>
                            <Box {...provided.dragHandleProps} ml={2}>
                                <Iconify icon={'lucide:grip'} width={32} height={32} />
                            </Box>
                            {category.children?.length ?
                                <Box sx={styles.arrowContainer}>
                                    <IconButton onClick={onOpenCloseAccordion}>
                                        <Iconify icon={open ? 'iconamoon:arrow-down-2-light' : 'iconamoon:arrow-right-2-light'} width={32} height={32} />
                                    </IconButton>
                                </Box> : <Box mx={2}/>}
                            {category.image ? <Box sx={styles.imageContainer}>
                                <Image image={category.image} sx={styles.image} />
                            </Box> : null}
                            <Box flexGrow={1} >
                                <Typography variant='body1' >{category.name}</Typography>
                            </Box>
                            <Box width={120} >
                                <IOSSwitch label={t('common.active')} name="available" onChange={onActiveSwitch} checked={category.available} />
                            </Box>
                            {parent?.slug === "serial" || category.slug === "serial"
                                ? (
                                    <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                                        <Iconify icon={'eva:more-vertical-fill'} />
                                    </IconButton>
                                ) : (
                                    <Tooltip title={t('common.edit')}>
                                        <IconButton size="large" color="inherit" onClick={onEdit}><Iconify icon={'eva:edit-fill'} /></IconButton>
                                    </Tooltip>
                                )
                            }
                            {/* <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                            <ContextMenu open={openMenu} onClose={handleCloseMenu} onDelete={onDelete} onEdit={onEdit} /> */}
                        </Box>
                    </StyledDraggedComponent>
                    {category?.slug === 'serial' ? <SerialCategoryContextMenu open={openMenu} onClose={handleCloseMenu} onAdd={onCreateSerialCategory} onEdit={onEdit} /> : null}
                    {parent?.slug === 'serial' ? <ContextMenu open={openMenu} onClose={handleCloseMenu} onDelete={onDelete} onEdit={onEdit} /> : null}
                    {category.children && open ? <CategoryDroppableContainer parent={category} level={level + 1} categories={category.children} /> : null}
                </Box>
            )}
        </Draggable>
    );
};
